(function () {
  if (window.__fussReveal) return;
  window.__fussReveal = true;

  var css = '.fuss-reveal-on .fuss-reveal{opacity:0;transform:translateY(32px);transition:opacity .9s cubic-bezier(.2,.7,.2,1),transform .9s cubic-bezier(.2,.7,.2,1);transition-delay:var(--d,0s)}' +
            '.fuss-reveal-on .fuss-reveal.is-visible{opacity:1;transform:none}' +
            '@media (prefers-reduced-motion:reduce){.fuss-reveal-on .fuss-reveal{opacity:1;transform:none;transition:none}}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);
  document.documentElement.classList.add('fuss-reveal-on');

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12 })
    : null;

  function scan() {
    document.querySelectorAll('.fuss-reveal:not(.is-visible)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-visible');
    });
  }

  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
  if (document.readyState !== 'loading') scan();
})();